<template>
    <section class="esesja-modal">
        <section class="esesja-modal__wraper" :class="`esesja-modal__wraper--${size}`">
            <slot></slot>
        </section>
    </section>
</template>
<script charset="utf-8">
    export default {
        name: "eSesjaModal",
        props: {
            size: {
                type: String,
                default: 'medium', // small, medium, large
            },
        },
    }
</script>